import { Box, Dialog, DialogContent, Divider, Typography } from "@mui/material"
import type { FC } from "react"
import React from "react"

import DialogHeader from "@/components/common/Modals/DialogHeader"
import { useAppView } from "@/hooks/useAppView"
import { PutAwayModalActions } from "@/screens/WarehouseReceiving/components/PalletComponents/PutAwayModalActions"

interface BulkPutAwayModalProps {
  palletCount: number
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
}

export const BulkPutAwayModal: FC<BulkPutAwayModalProps> = ({ palletCount, onClose, onConfirm, loading = false }) => {
  const { isTabletView } = useAppView()

  return (
    <Dialog open onClose={onClose} fullScreen={isTabletView} maxWidth='sm' fullWidth data-testid='bulk-put-away-modal'>
      <DialogHeader title='Bulk Put Away' onClose={onClose} />

      <DialogContent className='p-8'>
        <Typography variant='body1' className='mb-6'>
          Please ensure these are stored in their proper destinations.
        </Typography>

        <Box className='flex flex-col'>
          <Typography variant='h1' className='font-bold text-gray-900' sx={{ fontSize: { xs: "5rem", sm: "6rem" } }}>
            {palletCount}
          </Typography>
          <Typography variant='caption' color='text.secondary' className='text-lg'>
            Pallets
          </Typography>
        </Box>
      </DialogContent>
      <Divider />
      <PutAwayModalActions onCancel={onClose} onConfirm={onConfirm} loading={loading} />
    </Dialog>
  )
}
